import environment from '@/environment';
import { createHeaders, handleResponse } from '@/api/api-utils';
import { sceneConfigSchema, SceneData } from '@/schemas/sceneDataSchema';
import { clientInitSchema } from '@/schemas/clientInitSchema';

const authDenyList = ['bridge_auth_id', 'partner_public_id', 'auth', 'bridge_token'];

export async function initClient() {
  const query = new URLSearchParams(window.location.search);
  const url = new URL('quote/init', environment.serverBaseUrl);

  query.forEach((value, key) => {
    if (authDenyList.includes(key)) {
      return;
    }

    url.searchParams.append(key, value);
  });

  // Add query params if present
  const partner_public_id = query.get('bridge_auth_id');
  if (partner_public_id) {
    url.searchParams.append('partner_public_id', partner_public_id);
  }

  const bridge_token = query.get('auth');
  if (bridge_token) {
    url.searchParams.append('bridge_token', bridge_token);
  }

  const headers = createHeaders();
  const response = await fetch(url, { method: 'GET', headers });
  const responseData = await handleResponse(response);

  return clientInitSchema.parse(responseData);
}

export const getStep = async (entity_index?: number, step_id?: string): Promise<SceneData> => {
  const url = new URL('quote', environment.serverBaseUrl);

  if (entity_index !== undefined && step_id !== undefined) {
    url.searchParams.append('step_id', step_id);
    url.searchParams.append('entity_index', entity_index.toString());
  }

  const response = await fetch(url, { headers: createHeaders() });
  const responseData = await handleResponse(response);

  return sceneConfigSchema.parse(responseData);
};

export const submitStep = async (
  data: Record<string, Record<string, unknown>>,
  entity_index: number,
  step_id: string
): Promise<SceneData> => {
  const body = {
    entity_index,
    step_id,
    data,
  };

  const response = await fetch(`${environment.serverBaseUrl}/quote`, {
    method: 'POST',
    headers: createHeaders(),
    body: JSON.stringify(body),
  });

  const responseData = await handleResponse(response);
  return sceneConfigSchema.parse(responseData);
};
